<template>
<div class="el-dict-select">
    <el-select v-model="code" :disabled="disabled" :placeholder="placeholder" :clearable="clearable" :multiple="multiple" @change="onchange" :filterable="filterable">
        <el-option v-for="(item, index) in options" :key="String(index)" :value="item[props.value]" :label="item[props.label]"></el-option>
    </el-select>
</div>
</template>

<script>
export default {
    props: {
        value: {
            default: "",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            required: true,
            default: "",
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        filterable: {
            type: Boolean,
            default: true,
        },
        params: {
            type: Object,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        props: {
            type: Object,
            default: () => ({
                label: "name",
                value: "id",
            }),
        },
    },
    watch: {
        code(val) {
            this.$emit("input", val);
            this.init();
        },
        value(val) {
            this.code = val;
        },
        params: {
            deep: true,
            handler() {
                this.update();
            },
        },
    },
    data() {
        return {
            options: [],
            code: "",
        };
    },
    name: "ElDictSelect",
    created() {
        this.code = this.value;
        this.init();
    },
    methods: {
        getOptions() {
            return this.$http({
                url: this.$http.adornUrl(`common/${this.type}`),
                params: this.params,
                method: "get",
            });
        },
        init() {
            this.getOptions().then(({
                data
            }) => {
                this.options = data.data;
            });
        },
        update() {
            this.code = "";
            this.init();
        },
        onchange(val) {
            this.$emit("change", val);
        },
    },
};
</script>
